angular.module('bmsApp.global.direction', []);
